import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Modal from '@UI/antd/Modal'
import { RootState } from '@store/store'
import { rootActions } from '@store/slices'
import styles from './index.scss'

const VideoPlayerModal = () => {
    const dispatch = useDispatch()
    const playerRef = React.useRef(null)
    const { videoPlayerModalVisible } = useSelector((state: RootState) => state.ui.general)
    const { data: i18n } = useSelector((state: RootState) => state.localization.locals)
    const { isMeetingHubEvent } = useSelector((state: RootState) => state.ui.companyProfile)

    const hideVideoModal = () => {
        const iframeSrc = playerRef.current.src
        playerRef.current.src = iframeSrc
        dispatch(rootActions.ui.general.changeVideoPlayerModalVisiblity({ visible: false }))
    }

    return (
        <Modal
            footer={false}
            open={videoPlayerModalVisible}
            title={i18n.extraKeys?.Application_Demo}
            modalSize="large"
            onCancel={hideVideoModal}
            style={{ top: 20 }}
            className={styles['container']}
            forceRender
        >
            <iframe
                src={
                    isMeetingHubEvent
                        ? 'https://youtube.com/embed/f2_ojOwjVbw?autoplay=1&mute=1'
                        : 'https://share.synthesia.io/embeds/videos/4eaeac82-48d5-43e1-b338-1a79009727f5'
                }
                loading="lazy"
                title="Synthesia video player - Aladdin 3 Recorded Demo "
                allow="encrypted-media; fullscreen;"
                ref={playerRef}
                style={{
                    position: 'absolute',
                    width: '100%',
                    height: '100%',
                    top: 0,
                    left: 0,
                    border: 'none',
                    padding: 0,
                    margin: 0,
                    overflow: 'hidden'
                }}
            />
        </Modal>
    )
}

export default VideoPlayerModal
